import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const UK_PHONE_RE   = /^(\+44|44|0)7\d{9}$|^(\+44|44|0)[1-9]\d{8,9}$/

/** Normalise +447..., 447..., or 07... to the 07... local format. */
export function normalizePhone(raw: string): string {
  const s = raw.trim().replace(/\s+/g, '')
  if (s.startsWith('+44')) return '0' + s.slice(3)
  if (/^44\d{10}$/.test(s)) return '0' + s.slice(2)
  return s
}
export const UK_POSTCODE_RE = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i

export function toE164(phone: string): string {
  const v = phone.replace(/\s/g, '')
  if (v.startsWith('+44')) return v
  if (v.startsWith('0')) return '+44' + v.slice(1)
  return v
}

export function formatPostcode(input: string): string {
  const s = input.replace(/\s/g, '').toUpperCase().slice(0, 8)
  return s.length >= 5 ? s.slice(0, -3) + ' ' + s.slice(-3) : s
}

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount)
}

export function formatEta(minutes: number): string {
  if (minutes < 60) return `~${minutes} min`
  const hrs = Math.floor(minutes / 60)
  const mins = minutes % 60
  return mins > 0 ? `~${hrs}h ${mins}m` : `~${hrs} hour${hrs > 1 ? 's' : ''}`
}

export function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime()
  const secs = Math.floor(diff / 1000)
  if (secs < 60) return 'just now'
  const mins = Math.floor(secs / 60)
  if (mins < 60) return `${mins}m ago`
  return `${Math.floor(mins / 60)}h ago`
}

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function timeUntil(dateStr: string): string {
  const diff = new Date(dateStr).getTime() - Date.now()
  if (diff <= 0) return 'expired'
  const totalSecs = Math.floor(diff / 1000)
  const mins = Math.floor(totalSecs / 60)
  const secs = totalSecs % 60
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}
